<template>
    <div>
        <GmapMap
            ref="map"
            id="map"
            v-if="user"
            :center="{
                lat: user.location.latitude,
                lng: user.location.longitude,
            }"
            :zoom="user.map_zoom"
            :options="{zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    styles}"
            map-type-id="roadmap"
            class="map"
            @click="info.show = false"
            @zoom_changed="zoom_calc"
        >
            <div v-if="records">
                <div :key="meter.name" v-for="meter in meters">
                    <GmapMarker
                        id="meter.name"
                        v-if="meter.location"
                        :position="{
                            lat: meter.location.latitude,
                            lng: meter.location.longitude,
                        }"
                        :icon="getIcon(meter.name)"
                        :ref="meter.name"
                        :clickable="true"
                        @click="selectMarker($event, meter.name)"
                    />
                </div>
            </div>
        </GmapMap>
        <v-bottom-sheet v-model="info.show" inset hide-overlay max-width="450">
            <v-card>
                <v-list>
                    <v-list-item>
                        <v-list-item-content v-if="info.meter" class="ml-6 text-center">
                            <v-list-item-title>
                                <v-btn class="mb-n4" :to="{ name: 'Circuit', params: { id: info.meter.name } }" link text x-large>{{ info.meter.circuit || info.meter.name }}</v-btn>
                                <br>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-subtitle v-if="info.record" class="text-center">
                            <v-chip
                                class="ma-2"
                                color="primary"
                                text-color="white"
                                label
                            >
                                {{ info.record.lines.reduce( (suma, l) => suma + l.watts, 0 ).toFixed(2) }}
                                <v-avatar right>
                                        W
                                </v-avatar>
                            </v-chip>
                            <v-chip
                                class="ma-2"
                                color="primary"
                                text-color="white"
                                label
                            >
                                {{ info.record.lines.reduce( (suma, l) => suma + l.amps, 0 ).toFixed(2) }}
                                <v-avatar right>
                                        A
                                </v-avatar>
                            </v-chip>
                            <v-chip
                                class="ma-2"
                                color="primary"
                                text-color="white"
                                label
                            >
                                {{ (Object.entries(info.record.lines.reduce( (acc, l) => 
                                    l.volts > 10 
                                        ? acc = { suma: acc.suma + l.volts, lines: acc.lines + 1} : acc , 
                                        { suma: 0, lines: 0} )
                                    ).reduce( (total, el) => {
                                        if(el[0] == 'suma') return total + el[1];
                                        else if(total == 0) return 0;
                                        else return total / el[1]
                                    }, 0)).toFixed(2) 
                                }}
                                <v-avatar right>
                                        V
                                </v-avatar>
                            </v-chip>
                        </v-list-item-subtitle>
                    </v-list-item>
                </v-list>
                <div class="text-center mb-3">
                    <v-btn text small color="danger" @click="reportIssue(info.meter.name, info.meter.issue)">
                        Report Issue
                    </v-btn>
                    <v-btn text small color="accent" @click="solveIssue(info.meter.name, info.meter.issue)">
                        Mark as solved
                    </v-btn>
                    <br>
                    <v-btn text small color="grey" class="mt-1" @click="shareLocation(info.meter.name)">
                        Share Location
                    </v-btn>
                </div>
                <div class="text-center" v-if="info.record" style="font-size: 12px">
                    Last read: {{ info.date }}
                </div>
            </v-card>
        </v-bottom-sheet>
        <a href="https://mapicons.mapsmarker.com/" class="license">
            <img src="@/assets/map/license.gif" alt="license"  />
        </a>
        <v-snackbar v-model="snackbar">
            Location copied to clipboard
            <template v-slot:action="{ attrs }">
                <v-btn
                color="pink"
                text
                v-bind="attrs"
                @click="snackbar = false"
                > Close </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { default as mapStyle } from '../plugins/mapStyle.json'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'
export default {
    name: 'MapView',
    computed: {
        google: VueGoogleMaps.gmapApi,
        ...mapState({
            user: (state) => state.user.profile,
            meters: (state) =>
                state.meters.meters.map((m) => ({
                    name: m.name,
                    circuit: m.circuit,
                    location: m.location,
                    issue: m.issue
                })),
            records: (state) => state.meters.lastReadings,
            watts: (state) => state.meters.watts,
            arrayMeterLinks: state => 
                state.meters.arrayMeterLinks,
        }),
        mapCustom(){
            return mapStyle
        },
        styles(){
            return this.mapCustom
        }
    },
    data() {
        return {
            info: {
                show: false,
                issue: false,
                date: null
            },
            size: 0,
            issue: false,
            solved: false,
            mapLoaded: false,
            arrayWatts: [],
            gMapLink: '',
            snackbar: false,
            id: 0
        }
    },
    methods: {
        ...mapActions({ checkIssue: 'meters/checkIssue', uncheckIssue: 'meters/uncheckIssue', valuesWatts: 'meters/valuesWatts' }),
        selectMarker(e, meter) {
            this.info.show = false
            this.$refs.map.panTo({
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
            })
            this.info.meter = this.meters.find((m) => m.name == meter)
            this.info.record = this.records.find((m) => m ? m.meter == meter : false)
            this.info.show = true
            let day = new Date(this.info.record.timestamp).getDate()
            let m = new Date(this.info.record.timestamp).getMonth()
            let months = ['January','February','March','April','May','June','July','August','September','October','November','December']
            let hour = moment(new Date(this.info.record.timestamp).toLocaleTimeString(), "HH:mm:ss").format("HH:mm")
            this.info.date = months[m] + ' ' + String(day) + ' ' + hour
        },
        zoom_calc(){
            let zoomArr = [4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22]
            let sizeArr = [4,4,4,6,6,6,6,6,10,20,20,20,30,30,30,40,40,40,40]
            if (!this.$refs.map){
                let sizeIndex = 13
                this.size = sizeArr[sizeIndex]
                return
            }
            this.$refs.map.$mapPromise.then((map) => {
                let zoom = map.getZoom()                    
                let sizeIndex = zoomArr.findIndex(s => s == zoom)
                this.size = sizeArr[sizeIndex]
            })
        },
        getIcon(meter) {
            let record = this.records.find((m) => m ? m.meter == meter : false)
            let m = this.meters.find((n) => n ? n.name == meter : false)
            if(m.issue === true){
                return { url: require('@/assets/map/icon-purple.png'), 
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
                }
            }
            if (record !== undefined) {
                let signal = record.status.rssi
                let w = record.lines.reduce( (suma, l) => suma + l.watts, 0 ).toFixed(2)
                if( w > this.watts[0] && w <= this.watts[1] ){
                    return { url: require('@/assets/mapCons/01.png'), 
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},}
                } else if ( w > this.watts[1] && w <= this.watts[2] ){
                    return { url: require('@/assets/mapCons/12.png'),
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
                    }
                } else if ( w > this.watts[2] && w <= this.watts[3] ){
                    return { url: require('@/assets/mapCons/23.png'),
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
                    }
                } else if ( w > this.watts[3] && w <= this.watts[4] ){
                    return { url: require('@/assets/mapCons/34.png'),
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
                    }
                } else if ( w > this.watts[4] && w <= this.watts[5] ){ 
                    return { url: require('@/assets/mapCons/45.png'),
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
                    }
                } else {
                    return { url: require('@/assets/mapCons/56.png'),
                    scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
                    }
                }
            }   
            return { url: require('@/assets/map/icon-dark.png'),
                scaledSize: {width: this.size, height: this.size, f: 'px', b: 'px'},
            }
        },
        consumptionInfo(){
            let records = this.records
            for (let index = 0; 0 < records.length; index++) {
                const element = records[index];
                if(!element && index <= records.length-1) console.log(index)
                this.arrayWatts.push(element)
            }
        },
        async reportIssue(meter, prob) {
            this.issue = true
            this.info.meter.issue = this.issue
            let meter_id = meter
            let issue = this.issue
            await this.checkIssue({meter_id, issue})
            this.info.show = false
        },
        async solveIssue(meter, prob){
            this.issue = false
            this.info.meter.issue = this.issue
            let meter_id = meter
            let issue = this.issue
            await this.checkIssue({meter_id, issue})
            this.info.show = false
        },
        async shareLocation(meter){
            let m = this.meters.find((n) => n ? n.name == meter : false)
            let l = this.arrayMeterLinks.find((i) => i ? i.name == m.circuit : false)
            this.gMapLink = l.url
            let copyText = this.gMapLink
            navigator.clipboard.writeText(copyText)
            this.snackbar = true
        },
    },
    mounted(){
        this.zoom_calc()
    },
    watch:{
        records(){
            if(this.info.show) this.info.show = false
            this.$forceUpdate()
        },
    },
}
</script>

<style scoped>
.map {
    display: contents;
}
.license {
    position: absolute;
    z-index: 100;
    bottom: 10px;
    right: 8px;
}
</style>
